import { OSS_URL_PREFIX,OSS_URL } from '@/config/config'

export const parseTime = function(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

export const toNextTimes = function(n){
  return +new Date() + n * 86400000;
}

export const formatNumber = function(n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}

export const formatTime = function(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export const formatTime2 = function(date, type=0, deadline = 0) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate() + deadline

  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  const t1 = [year, month, day].map(formatNumber)
  const t2 = [hour, minute, second].map(formatNumber)

  const t3 = [year, month, day].map(formatNumber).join('-')
  const t4 = [hour, minute, second].map(formatNumber).join(':')

  const t5 = [year, month, day].map(formatNumber).join('/')

  switch(type) {
    case 0:
      return `${t3} ${t4}`
    case 1:
      return `${t3}`
    case 2:
      return `${t4}`
    case 3:
      return [...t1, ...t2]
    case 4:
      return `${t5} ${t4}`
    case 5:
      return `${t5}`
    default:
      break;
  }

}

export const param2Obj = function(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export const GET_OSS_URL = function(name, type = 'png') {
  return `${OSS_URL_PREFIX}${name}.${type}`
}

export const debounce = function(fn, delay) {
    let timer = null
    return function(...args) {
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => {
            fn.apply(this, args)
        }, delay)
    }
}

export const ossFileURL = function(fileName, fileType="png") {
  if (typeof fileName !== "string") {
    throw new TypeError("fileName is not a string");
  }
  return `${OSS_URL}${fileName}.${fileType}`;
}
